$(document).ready(function () {
    menuOpen();
})

$(window).resize(function () {
    menuOpen()
})

function menuOpen() {
    if ($(window).width() < 992) {
        $(document).on('click', '.js__open_menu_mobile', function () {
            $(this).addClass('open');
            $('.main_header').addClass('open');

            $('footer').after('<div class="menu_bg_close"></div>');
            $('body').addClass('overflow');
        });

        $(document).on('click', '.js__close_menu, .menu_bg_close', function () {
            $('.js__open_menu_mobile').removeClass('open');
            $('.main_header').removeClass('open');
            $('.menu_bg_close').remove();
            $('body').removeClass('overflow');
        });

        $(document).on('click', '.menu_arrow', function (e) {
            $(this).closest('.item').toggleClass('js__open');
            $(this).closest('.item').find('.js__menu_mobile').slideToggle();
        })
    }

}



// WEBPACK FOOTER //
// ./resources/js/components/menu.js